<template>
  <div>
    <div
      class="floorThree"
      :style="{ backgroundImage: 'url(' + objimg + ')' }"
    >
      <div class="title_box">
        <div class="en">MATERIAL ADVANTAGES</div>
        <div class="zh">科技材料，革新体验</div>
        <div class="line"></div>
      </div>
      <div class="for_box">
        <div class="item_box" v-for="(item, index) in arr" :key="index">
          <div class="center_item">
            <div class="icon">
              <img class="img_cover" :src="item.image" alt="" />
            </div>
            <div class="text_box">
              <div class="zh">{{ item.name }}</div>
              <div class="en">{{ item.en }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      arr: [],
      obj: {},
      objimg:"",
    };
  },
  methods: {},
  mounted() {
    var index = Number(this.$route.query.id);
      var indata = Number(this.$route.query.in);
    // if (this.floorData.length === 0) {
    //   // setTimeout(() => {
    //     this.obj = this.$store.state.floorData[index];
    //     this.arr = this.obj.experience_mode;
    //   // }, 500);
    // } else {
     
      if (index==0) {
             this.obj = this.$store.state.floorData[index]  || JSON.parse(localStorage.getItem('floorData'))[index] ;
      this.arr = this.obj.children[indata].experience_mode;
      this.objimg=this.obj.children[indata].experience_background
      }else{
      this.obj = this.$store.state.floorData[index] || JSON.parse(localStorage.getItem('floorData'))[index];
      this.arr = this.obj.experience_mode;
           this.objimg=this.obj.experience_background
      }

    // }
  },
  computed: {
    floorData() {
      return this.$store.state.floorData;
    },
  },
  watch:{
    floorData(val){
      console.log(val)
    }
  }
};
</script>

<style scoped lang='scss'>
.floorThree {
  width: 100%;
  height: 100vh;
  // background-image: url("../../assets/components_img/temporary/floor_three_back.png");
  background-size: cover;
.title_box {
    width: 100vw;
    height: 9.3vh;
    padding-top: 16vh;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      line-height: 2.8vh;
      text-align: center;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      margin-top: -2vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .for_box {
    width: 75.14vw;
    height: 18.75vh;
    margin: 0 auto;
    // margin-top: 164px;
    margin-top: 16.04vh;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    .item_box {
      width: 16.29vw;
      // height: 140px;
      height: 14vh;
      border: 1px solid #ffffff;
      margin: 0 1vw;
      // margin-bottom: 80px;
      margin-bottom: 8vh;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.5s;
      .center_item {
        // width: 14.58vw;
        // height: 60px;
        height: 6vh;
        display: flex;
        justify-content: space-around;
        .icon {
          width: 60px;
          height: 60px;
        }
        .text_box {
          // width: 10vw;
          height: 100%;
          margin-left: 1vw;
          .zh {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 24px;
            line-height: 2.4vh;
            color: #ffffff;
            // text-align: center;
          }
          .en {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 16px;
            line-height: 1.8vh;
            color: #ffffff;
            // margin-top: 10px;
            margin-top: 1vh;
            // text-align: center;
          }
        }
      }
    }
    .item_box:hover {
      background: rgba(15, 255, 255, 0.2);
      border: 1px solid #0fffff;
      cursor: url("../../assets/cursor.png"), none;
      transition: all 0.5s;
    }
  }
}
</style>